
import { useState, useEffect } from 'react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen bg-gradient-to-b from-blue-900 via-blue-950 to-black flex items-center justify-center overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-2 h-2 bg-white/20 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-1 h-1 bg-white/30 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute bottom-40 left-20 w-1.5 h-1.5 bg-white/25 rounded-full animate-pulse delay-2000"></div>
        <div className="absolute bottom-60 right-40 w-1 h-1 bg-white/20 rounded-full animate-pulse delay-3000"></div>
      </div>

      <div className="container mx-auto px-6 text-center relative z-10">
        {/* Logo */}
        <div className={`mb-12 transform transition-all duration-2000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <div className="inline-flex items-center justify-center w-32 h-32 mx-auto mb-8 relative">
            <img 
              src="https://static.readdy.ai/image/0e46e23e46c8c9dfddbf3ffa9f8570fe/7c8fb1bd017777596a8092832d4ffea3.png" 
              alt="StartupCoin Logo" 
              className="w-full h-full object-contain animate-pulse"
            />
          </div>
        </div>

        {/* Main Heading */}
        <div className={`mb-8 transform transition-all duration-2000 delay-500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <h1 className="text-6xl md:text-8xl font-bold text-white mb-6 tracking-tight">
            StartupCoin
          </h1>
          <div className="text-2xl md:text-3xl text-blue-200 font-light mb-4">
            $Startup
          </div>
        </div>

        {/* Tagline */}
        <div className={`mb-12 transform transition-all duration-2000 delay-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <p className="text-xl md:text-2xl text-white/90 font-light max-w-3xl mx-auto leading-relaxed">
            The crypto that turns dreams into projects
          </p>
          <p className="text-lg md:text-xl text-blue-200 font-light mt-6 max-w-2xl mx-auto">
            From dream to startup — powered by the people
          </p>
        </div>

        {/* CTA Buttons */}
        <div className={`flex flex-col sm:flex-row gap-6 justify-center items-center transform transition-all duration-2000 delay-1500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <a
            href="https://pump.fun/"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Join the Movement
            <i className="ri-rocket-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
          </a>
        </div>

        {/* Floating animation for scroll indicator */}
        <div className={`absolute bottom-8 left-1/2 transform -translate-x-1/2 transition-all duration-2000 delay-2000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="animate-bounce">
            <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
